export const BRAND = {
  name: "BuildOnce Studio",
  tagline: "When the strategy lives in your head, the business has to keep guessing.",
  logoUrl:
    "https://customer-assets.emergentagent.com/job_6be5423a-7dbc-45e7-b35a-abd115c844e4/artifacts/fwrhud4y_BoS.png",
  founderPhotoUrl:
    "https://customer-assets.emergentagent.com/job_web-creator-2182/artifacts/kny32xzw_Screenshot%202025-09-03%20at%208.50.04%20PM.png",
  email: "info@buildoncestudio.com",
};

export const SERVICES = [
  {
    id: "clarity-kit",
    name: "BuildOnce Clarity Kit",
    eyebrow: "Self-guided decision-making tool",
    summary:
      "A self-guided clarity tool for professionals and independent experts who need to decide what to build, say, and sell first.",
    bullets: [
      "Interactive web app",
      "PDF workbook",
      "7 editable templates",
      "AI reflections after each section",
      "Clarity Check",
      "Final clarity summary",
      "Diagnostic credit within 30 days",
    ],
    duration: "At your pace",
    pricing: "SGD 97 founding price · Standard SGD 149",
    audience: "Corporate leavers, early solopreneurs, independent consultants, coaches, fractional leaders",
    cta: { text: "Get it now →", to: "/clarity-kit" },
    secondaryCta: { text: "Try the Free Clarity Check", to: "/clarity-diagnostic" },
  },
  {
    id: "diagnostic",
    name: "BuildOnce Diagnostic",
    eyebrow: "Clarity gaps & next move",
    summary:
      "A 75-minute working session for people who have completed the Clarity Kit or already have a rough direction, but want a second pair of eyes on their clarity gaps, positioning, and offer friction points.",
    details: [
      {
        label: "How it differs from a discovery call",
        body: "Unlike the discovery call, this session ends with a written summary: what is clear, what is not, and a specific recommended next step.",
      },
    ],
    bullets: [
      "Clarity gaps",
      "Positioning diagnosis",
      "Offer friction points",
      "Recommended next step",
    ],
    duration: "75 minutes",
    pricing: "SGD 450 · Clarity Kit clients can apply the amount paid within 30 days",
    audience: "Founders who feel friction but do not know whether the issue is positioning, offer architecture, messaging, or timing",
    cta: { text: "Book the session →", to: "/booking" },
  },
  {
    id: "sprint-lite",
    name: "Clarity Sprint Lite",
    eyebrow: "Positioning for solo experts",
    summary:
      "A four-session sprint for solo experts who need clearer positioning, a stronger offer, and language they can actually use, in their sales page, profile, referral conversations, content, and discovery calls.",
    bullets: [
      "Positioning brief",
      "Offer structure",
      "Messaging spine",
      "60-day action plan",
    ],
    duration: "Four working sessions",
    pricing: "SGD 2,800",
    audience: "Consultants, advisors, coaches, fractional leaders",
    cta: { text: "Start the conversation", to: "/booking" },
  },
  {
    id: "clarity-sprint",
    name: "Clarity Sprint",
    eyebrow: "Core strategy foundation",
    summary:
      "A six-week sprint that turns what is in the founder's head into positioning, offer structure, and shared language the team can actually work from.",
    details: [
      {
        label: "Ends with",
        body: "A written brief covering positioning, customer profile, offer architecture, messaging spine, and a 90-day action plan.",
      },
      {
        label: "What we need from you",
        body: "Six weeks of committed time, decision-makers in the room, and willingness to give honest answers to difficult questions.",
      },
    ],
    bullets: [
      "Customer profile",
      "Positioning brief",
      "Offer architecture",
      "Messaging spine",
      "90-day action plan",
    ],
    duration: "Six weeks",
    pricing: "From SGD 6,500 · Scoped per engagement",
    audience: "Founder-led SMEs and expert-led teams",
    featured: true,
    cta: { text: "Book a discovery call", to: "/booking" },
  },
  {
    id: "momentum",
    name: "Momentum Advisory",
    eyebrow: "Ongoing decision support",
    summary:
      "For clients who have built the foundation and want a thinking partner as they apply it. The goal is to reach a point where you no longer need this.",
    details: [
      {
        label: "What a month includes",
        body: "Two structured working conversations, async support between sessions, and a short written summary of decisions made and open questions to carry forward. Once a quarter, we revisit your positioning and messaging to check if anything has shifted.",
      },
    ],
    bullets: [
      "Two working sessions per month",
      "Async support between sessions",
      "Monthly decision log",
      "Quarterly positioning and messaging review",
    ],
    duration: "Three-month minimum",
    pricing: "SGD 1,800 per month · Three-month minimum (SGD 5,400 total)",
    audience: "Post-sprint clients",
    cta: { text: "Start the conversation", to: "/booking" },
  },
  {
    id: "ai-clarity-workshop",
    name: "AI Clarity Workshop",
    eyebrow: "AI as a business decision",
    summary:
      "A practical workshop for leaders who want to understand where AI actually belongs in their business before spending money on tools or vendors.",
    details: [
      {
        label: "Ends with",
        body: "A mapped view of where AI fits your real workflows, which use cases are worth testing, and a clear decision on where to start.",
      },
      {
        label: "What this is not",
        body: "Not a software demo. Not a trends briefing. A working session about your business.",
      },
    ],
    bullets: [
      "AI readiness snapshot",
      "Use case map",
      "Risk considerations",
      "30-day pilot plan",
    ],
    duration: "Half day",
    pricing: "On request",
    audience: "SME owners, L&D leaders, service businesses",
    cta: { text: "Let's talk about fit", to: "/booking" },
  },
  {
    id: "ai-pilot-advisory",
    name: "AI Pilot Advisory",
    eyebrow: "First AI pilot support",
    summary:
      "A four-week advisory engagement turning one AI use case into a responsible first pilot. This engagement is scoped to your specific use case. If you have completed the AI Clarity Workshop, we will use what we already know about your business as the starting point.",
    bullets: [
      "Pilot scope",
      "Decision criteria",
      "Adoption risks",
      "Review rhythm",
    ],
    duration: "Four weeks",
    pricing: "On request · Typically in the range of the AI Clarity Workshop",
    audience: "Post-workshop clients",
    cta: { text: "Let's talk about fit", to: "/booking" },
  },
];

export const VALUES = [
  {
    title: "Clarity Before Movement",
    body: "We ask before we prescribe, because the wrong diagnosis makes every next step more expensive.",
  },
  {
    title: "In It With You",
    body: "Founder-led by design. You work directly with the people doing the thinking, not through a layered account team.",
  },
  {
    title: "Build It Once. Build It Right.",
    body: "We are not interested in rebuilding what is already working, or patching what needs to be rebuilt. The work starts by knowing which is which.",
  },
];

export const AUDIENCES = [
  {
    title: "Founder-led SMEs",
    body: "Businesses built on instinct that are ready for structure, clearer positioning, and a steadier next chapter.",
  },
  {
    title: "Expert-led businesses",
    body: "Consultants, coaches, fractional leaders, and specialists with strong expertise and unclear messaging.",
  },
  {
    title: "Leaders navigating AI",
    body: "SME owners and business unit leaders who want a pragmatic frame for AI, not a software shopping list.",
  },
  {
    title: "Self-guided builders",
    body: "Early solopreneurs and corporate leavers who want a thoughtful starting point before working with anyone.",
  },
];

export const PRACTICE_HIGHLIGHTS = [
  {
    discipline: "Operational Architecture",
    sector: "Multi-entity advisory practice",
    region: "Philippines",
    result:
      "A 25-person team spanning four business lines split into two leadership roles: one holding daily delivery, one evaluating what comes next. Of three AI use cases considered, one moved into a measured pilot, the rest deferred or set aside with the reasoning attached.",
    caseStudyUrl:
      "https://drive.google.com/file/d/1BWJXWX28nB9uMzjzyj0MlNjPf5RI7wS-/view",
  },
  {
    discipline: "Launch Planning",
    sector: "Founder-led brand",
    region: "Singapore",
    result:
      "A founder's plan existed only in her head. It became one working document with a dated execution guide, built around four decisions made together. Measured outcomes will follow once the brand publicly launches.",
    caseStudyUrl:
      "https://drive.google.com/file/d/1FmIrqlJhXNTRUlKQpu-pn3uICdRcY3WV/view",
  },
  {
    discipline: "Messaging System",
    sector: "Boutique luxury brand distributor",
    region: "Asia",
    result:
      "A single messaging spine now used consistently across four markets, replacing improvised, partner-by-partner pitches. Local teams lead partner conversations independently, without positioning drifting when the founder isn't in the room.",
    caseStudyUrl:
      "https://drive.google.com/file/d/11aNCX3vffiRqcKqVA95hKgJuRx4RP7wM/view",
  },
];

export const TIME_SLOTS = [
  "09:00",
  "10:00",
  "11:00",
  "13:00",
  "14:00",
  "15:00",
  "16:00",
];
